// extracted by mini-css-extract-plugin
export default {"dashboard-personal":"style_dashboard-personal__+CpTf","dashboard-header":"style_dashboard-header__lx7D9","dashboard-banner":"style_dashboard-banner__qp3hR"};